import { Tooltip, TooltipPlace, icons, randomUUID } from '@chillibean/component-library';
import { Icon } from '@iconify/react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function SpecialLock(props) {
  const { disabled = true, tooltip = null } = props;

  return (
    <Tooltip content={disabled ? tooltip : null} id={`special-lock-${randomUUID()}`} place={TooltipPlace.LEFT}>
      <IconContainer data-test-id="unlock-button">
        <Icon
          className={clsx({
            disabled: disabled,
            lock: true,
          })}
          height={24}
          icon={icons.baselineLock}
          width={24}
        />
        {!disabled && (
          <Icon
            className={clsx({
              disabled: disabled,
              unlock: true,
            })}
            height={24}
            icon={icons.baselineUnlock}
            width={24}
          />
        )}
      </IconContainer>
    </Tooltip>
  );
}

const IconContainer = styled.div`
  > svg.lock {
    top: 0;
    opacity: 1;
  }

  > svg.lock:not(.disabled) {
    position: absolute;
  }

  > svg.unlock {
    opacity: 0;
  }

  &:hover {
    > svg:not(.disabled) {
      cursor: pointer;
    }

    > svg.lock:not(.disabled) {
      opacity: 0;
      transition: all 0.3s ease-in-out;
    }

    > svg.unlock:not(.disabled) {
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;

SpecialLock.propTypes = {
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
};

export default SpecialLock;
